import React from "react"

import { Box, colors, InputBase } from "@mui/material"

export const TextInput = (props: {
	inputValue: string
	leaveEditMode: () => void
	enterEditMode: () => void
	setInputValue: React.Dispatch<React.SetStateAction<string>>
	isEdit: boolean
}) => {
	const { inputValue, leaveEditMode, enterEditMode, setInputValue, isEdit } = props
	return !isEdit ? (
		<Box
			onClick={enterEditMode}
			sx={{
				height: "100%",
				p: "4px 8px 5px 8px",
				color: colors.grey[800],
				overflow: "hidden",
				whiteSpace: "nowrap",
				display: "flex",
				alignItems: "center",
			}}
		>
			{inputValue}
		</Box>
	) : (
		<InputBase
			type="text"
			value={inputValue}
			onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
				setInputValue(e.target.value)
			}}
			onBlur={leaveEditMode}
			autoFocus
			fullWidth
			sx={{
				height: "100%",
				px: "8px",
				color: colors.grey[800],
				boxSizing: "border-box",
				"&.Mui-focused": {
					border: 1,
					px: "7px",
					borderColor: "primary.main",
				},
			}}
		/>
	)
}
